import React from 'react';

const WEIGHT_CLASS = {
  medium: 'font-500',
  bold: 'font-700',
};

const SIZE_CLASS = {
  md: 'text-md leading-8',
  lg: 'text-lg leading-16',
};

export interface TitleProps {
  children: React.ReactNode;
  weight?: keyof typeof WEIGHT_CLASS;
  size?: keyof typeof SIZE_CLASS;
  style?: React.CSSProperties;
}

export const DialogTitle = React.forwardRef<HTMLElement, TitleProps>(
  function DialogTitle(
    { children, weight = 'medium', size = 'md', ...props }: TitleProps,
    ref
  ) {
    // could add a truncate class to the span bellow to make the title of the item a single line instead of multiple lines in case of long titles
    return (
      <span
        className={`font-display ${SIZE_CLASS[size]} ${WEIGHT_CLASS[weight]} text-blue-900 outline-none max-w-full`}
        style={{
          ...props.style,
          overflowWrap: 'break-word',
        }}
        ref={ref}
        tabIndex={-1}
      >
        {children}
      </span>
    );
  }
);
